import React, { useState, useEffect } from "react";
import { withRouter } from "../_shared/withRouter";
import { useTranslation } from "react-i18next";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import UserTable from "../template/admin/userTable";
import SidebarArrow from "../template/_common/sidebarArrow";
import { globalAlert, globalLoader } from "../actions/commonActions";
import AddUserModal from "../template/admin/addUserModal";
import NotificationModal from '../template/admin/notificationModal'
import {
  getUsersList,
  addUserApi,
  deleteUserApi,
  userEmergencyOverrideApi,
  addNotificationApi,
  adminZonerListApi,
  updateUserApi
} from "./_actions";
import ConfirmationModal from "../template/_common/confirmModal";
import { formatDate } from "../i18n/dateLocale";
import { Helmet } from "react-helmet";
import PaginationOwn from "../template/_common/ownPagination";
import { compareValues, logOut } from "../_shared/commonFunction";
import InputComponent from "../template/_common/inputComponent";
import arraySort from 'array-sort';
import { Select, FormControl, MenuItem, InputLabel } from "@mui/material";
import DatePicker from "react-date-picker";
import { CSVLink } from "react-csv";


const ManageUser = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  const [editDataIs, setEditDataIs] = useState(false);
  const [confirmaModalOpen, setConfirmaModalOpen] = useState(false);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [pageSize, setPageSize] = useState(25);
  const [searchVal, setSearchVal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentDataList, setCurrentDataList] = useState([]);
  const [sortObj, setSortObj] = useState({});
  const [currentDataSorted, setCurrentDataSorted] = useState([]);
  const [notFilteredRun, setNotFilteredRun] = useState(false);
  const [totalCount, setTotalCount] = useState(false);
  const [allowView, setAllowView] = useState(false);
  const [confirmInfo, setConfirmInfo] = useState(null);
  const [confirmationType, setConfirmationType] = useState("");
  const [confirmHeading, setConfirmHeading] = useState('');
  const [zoneList, setZoneList] = useState(null);
  const [zoneValue, setZoneValue] = useState('All');

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [toMinDate, setToMinDate] = useState(null);
  const [fromMaxDate, setFromMaxDate] = useState(new Date());

  const headers = [
    { label: t("admin.users.csvHeaders.phone"), key: "mobile" },
    { label: t("admin.users.csvHeaders.postCode"), key: "postalCode" },
    { label: t("admin.users.csvHeaders.zone"), key: "zone" },
    { label: t("admin.users.csvHeaders.dateOfBirth"), key: "dateOfBirth" },
    { label: t("admin.users.csvHeaders.gender"), key: "gender" },
    { label: t("admin.users.csvHeaders.registrationDate"), key: "created" },
    { label: t("admin.users.csvHeaders.uuid"), key: "uuid" },
    { label: t("admin.users.csvHeaders.lastOverride"), key: "lastOverrideOn" },
    { label: t("admin.users.csvHeaders.totalOverrides"), key: "totalOverrides" },
  ];

  const setFromDateFunc = (val) => {
    setFromDate(val);
    setToMinDate(val);
  };

  const setToDateFunc = (val) => {
    setToDate(val);
    setFromMaxDate(val);
  };

  const handleSidebar = (data) => {
    setNavbarToggle(data);
  };

  useEffect(() => {
    callBasicApi(true); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    callBasicApi(); // eslint-disable-next-line
  }, [zoneValue, fromDate, toDate]);

  const callBasicApi = async (zoneApiCall = null) => {
    try {
      globalLoader(true);

      if (zoneApiCall) {
        const res = await adminZonerListApi();
        if (res?.data?.status === 200) {
          setZoneList(res?.data?.data?.zones);
        }
      }
      const query = `?zone=${zoneValue}&fromDate=${fromDate}&toDate=${toDate}`;
      let res = await getUsersList(query);
      if (res?.data?.status === 200) {
        setAllowView(true);
        let currData = res?.data?.data?.usersList;
        setDataList(currData);
        // setDataList(res?.data?.data?.usersList);
        setCurrentDataSorted(res?.data?.data?.usersList);
        !searchVal && setTotalCount(res?.data?.data?.usersList.length);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/admin/login");
      }
      globalLoader(false);
    }
  };

  const handleFilterChangeZone = (ev) => {
    if (ev?.target?.value) {
      setZoneValue(ev?.target?.value)
    }
  };

  const closeAddUserModal = async (val = null) => {
    if (val) {
      globalLoader(true);
      let res;
      if (editDataIs) {
        res = await updateUserApi(val, currentData?.userId);
      } else {
        res = await addUserApi(val);
      }
      if (res?.data?.status === 200) {
        globalAlert("success", res?.data?.message);
        setNotFilteredRun(false);
        setEditDataIs(false);
        setCurrentData(null);
        setOpenAddUserModal(false);
        callBasicApi();
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } else {
      setEditDataIs(false);
      setCurrentData(null);
      setOpenAddUserModal(false);
    }
  };

  const editData = (data) => {
    setEditDataIs(true);
    setCurrentData(data);
    setOpenAddUserModal(true);
  };

  const confirmModalFunc = async (val) => {
    try {
      if (val) {
        globalLoader(true);

        let res;
        if (confirmationType === 'override') {
          res = await userEmergencyOverrideApi(currentUserId);
        }
        else {
          res = await deleteUserApi(currentUserId);
        }
        if (res?.data?.status === 200) {
          setEditDataIs(false);
          setCurrentData(null);
          setOpenAddUserModal(false);
          setNotFilteredRun(false);
          if (totalCount === 1) setSearchVal("");
          callBasicApi();

        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
        setConfirmaModalOpen(false);

      }
      else {
        setConfirmaModalOpen(false);

      }
    }

    catch (err) {
      globalAlert("error", err?.response?.data?.message);
      globalLoader(false);
    }

  };

  const deleteData = (data) => {
    setCurrentUserId(data?.userId);
    let obj = [`Mobile : ${data?.mobile}`];
    setConfirmInfo(obj);
    setConfirmHeading(t("admin.users.confirmDeleteUser"))
    setConfirmaModalOpen(true);
    setConfirmationType('delete')
  };

  const emergencyOverride = (data) => {
    setCurrentUserId(data?.userId);
    let obj = [`Mobile : ${data?.mobile}`];
    setConfirmInfo(obj);
    setConfirmHeading(t("admin.users.confirmEmergencyOverride"))
    setConfirmaModalOpen(true);
    setConfirmationType('override')
  };

  useEffect(() => {
    if (!notFilteredRun) {
      filteredDataFunc();
    } // eslint-disable-next-line
  }, [pageSize, currentPage, sortObj, currentDataSorted, dataList]);

  const filteredDataFunc = (dataArray = null, localPage = null) => {
    let arr = [...dataList];

    let filterArr = [];
    let filteredData = [];
    if (dataArray) {
      arr = [...dataArray]
    }
    else {
      arr = arraySort(arr, compareValues(sortObj?.sortVal), { reverse: sortObj?.sortType === 'desc' ? true : false });
    }
    if (searchVal.length > 0) {
      filterArr = arr.filter((data) => {
        let dateOfBirth = formatDate(new Date(data?.dateOfBirth));
        if (
          data?.mobile.includes(searchVal) ||
          data?.postalCode.includes(searchVal) ||
          dateOfBirth.toLowerCase().includes(searchVal.toLowerCase())
        ) {
          return data;
        } else {
          return null;
        }
      });
    } else {
      filterArr = arr;
    }
    if (filterArr && filterArr.length > 0) {
      setTotalCount(filterArr.length);
      for (
        let i = (localPage || currentPage) * pageSize - pageSize;
        i < (localPage || currentPage) * pageSize && i < filterArr.length;
        i++
      ) {
        filteredData.push(filterArr[i]);
      }
    }
    setCurrentDataList(filteredData);
  };

  const changePageSizeFunc = async (val) => {
    setNotFilteredRun(false);
    setPageSize(val.target.value);
    setCurrentPage(1);
    setSortObj(null);
  };

  const searchFilter = (ev) => {
    ev.preventDefault();
    let arr = [...dataList];
    let filterArr = arr.filter((data) => {
      let dateOfBirth = formatDate(new Date(data?.dateOfBirth));
      if (
        data?.mobile.includes(searchVal) ||
        data?.postalCode.includes(searchVal) ||
        dateOfBirth.toLowerCase().includes(searchVal.toLowerCase())
      ) {
        return data;
      } else return null;
    });
    setTotalCount(filterArr.length);
    setNotFilteredRun(true);
    setCurrentDataList(filterArr);
    setCurrentPage(1);
    setSortObj(null);
  };

  const goToPageFunc = (val, data) => {
    setNotFilteredRun(false);
    if (data === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (
      data === "next" &&
      currentPage <
      Math.ceil(dataList?.length / pageSize)
    ) {
      setCurrentPage(currentPage + 1);
    } else {
      setCurrentPage(val?.target?.value);
    }
  };

  const arraySorting = (val) => {
    let arr = [...dataList];
    let sortedArr;
    let sortType = "desc";
    if (val && val === sortObj?.sortVal && sortObj?.sortType === "desc") {
      sortType = "asec";
    }
    sortedArr = arraySort(arr, compareValues(val), { reverse: sortType === 'desc' ? true : false })
    setNotFilteredRun(true);
    setCurrentPage(1);
    setSortObj({
      sortVal: val,
      sortType: sortType,
    });
    filteredDataFunc(sortedArr, 1)
  };

  const closeNotificationModal = async (val = null) => {
    if (val) {
      globalLoader(true);
      let res = await addNotificationApi(val);
      if (res?.data?.status === 200) {
        globalAlert("success", res?.data?.message);
        setNotificationModalOpen(false)

      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);

    } else {
      setNotificationModalOpen(false)

    }
  }

  const mapCsvList = () => {
    const list = [];
    dataList?.forEach(x => {
      list?.push({
        mobile: x?.mobile || "N/A",
        postalCode: x?.postalCode || "N/A",
        zone: x?.zone || "N/A",
        dateOfBirth: x?.dateOfBirth ? formatDate(new Date(x?.dateOfBirth)) : "N/A",
        gender: x?.gender == "not_disclosed" ? t("admin.users.notDisclosed") : x?.gender?.toUpperCase() || "N/A",
        created: x?.created ? formatDate(new Date(x?.created)) : "N/A",
        uuid: x?.uuid || "N/A",
        lastOverrideOn: x?.lastOverrideOn || "N/A",
        totalOverrides: x?.totalOverrides || "N/A",
      });
    });
    return list;
  };

  return (
    <>
      <Helmet>
        <title>{t("admin.pageTitle.manageUsers")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      {allowView && (
        <div className="admin-portal">
          <Header roleType="admin" />
          <div className={`${navbarToggle ? "active" : ""} wrapper`}>
            <SidebarComponent
              navbarToggle={navbarToggle}
              active={props.match.path}
            />
            <div className="main">
              <div className="main-wrapper">
                <div>
                  <p className="admin-banner">{t("admin.users.title")}</p>
                </div>
                <SidebarArrow handleSidebarToggle={handleSidebar} />
                <div>
                  <div className="container-fluid">
                    <div className="row col-12 form-report my-2">
                      <div className="form-report-group date-picker-class">
                        <label htmlFor="fromDate">{t("common.from")}</label>
                        <div className="datepicker-report">
                          <DatePicker
                            id="fromDate"
                            value={fromDate}
                            onChange={(ev) => setFromDateFunc(ev)}
                            maxDate={fromMaxDate}
                            format={"dd/MM/yyy"}
                          />
                        </div>
                      </div>
                      <div className="form-report-group date-picker-class">
                        <label htmlFor="toDate">{t("common.to")}</label>
                        <div className="datepicker-report">
                          <DatePicker
                            id="toDate"
                            value={toDate}
                            onChange={(ev) => setToDateFunc(ev)}
                            maxDate={new Date()}
                            format={"dd/MM/yyy"}
                            minDate={toMinDate}
                          />
                        </div>
                      </div>
                      {zoneList?.length > 0 &&
                        <div className="show-item-page filter-type form-own ml-3 form-report-group">
                          <FormControl variant="outlined" size="small">
                            <InputLabel id="show_per_page">{t("admin.users.userZone")}</InputLabel>
                            <Select
                              labelId="show_per_page"
                              id="demo-simple-select-outlined"
                              value={zoneValue || ''}
                              onChange={handleFilterChangeZone}
                              label={t("admin.users.userZone")}
                              name="pageSize"
                            >
                              {
                                zoneList.length > 0 &&
                                zoneList.map((data, index) => (
                                  <MenuItem value={data.value} key={index}>
                                    {data.label}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </div>
                      }
                    </div>
                    <div className="row admin-controls">
                      <form onSubmit={searchFilter} className="col-12 col-lg-6 admin-search">
                        <div className="search-wrapper">
                          <InputComponent
                            placeholder={t("admin.users.searchPlaceholder")}
                            label={t("admin.users.searchPlaceholder")}
                            type="text"
                            name="search"
                            theme="admin"
                            value={searchVal}
                            handleCallback={(val) => {
                              setSearchVal(val);
                            }}
                          />
                        </div>
                        <button type="submit" className="btn secondary-btn">
                          {t("common.go")}
                        </button>
                      </form>
                      <div className="col-12 col-lg-6 admin-add-new mt-lg-0 d-flex justify-content-start justify-content-lg-end gap-3">
                      <div className="download-btn mr-3">
                        <CSVLink
                          className="btn admin-btn secondary-btn"
                          data={mapCsvList()}
                          filename={"users-list.csv"}
                          headers={headers}
                        >
                          {t("common.downloadCsv")}
                        </CSVLink>
                      </div>
                        <div>

                          <div>
                            <button
                              onClick={() => setOpenAddUserModal(true)}
                              className="btn secondary-btn modal-btn"
                            >
                              <i className="fas fa-plus"></i> {t("admin.users.addButton")}
                            </button>
                          </div>
                        </div>

                      </div>
                      {dataList?.length > 0 && (
                        <div
                          className="px-3 col-12 pt-3"
                          style={{ borderTop: "2px solid #ebeef1" }}
                        >
                          <PaginationOwn
                            pageSize={pageSize}
                            changePageSize={changePageSizeFunc}
                            goToPage={goToPageFunc}
                            // totalCount={dataList?.length}
                            totalCount={totalCount}
                            currentPage={currentPage}
                            applicationType={
                              currentDataList?.length > 1 ? "users" : "user"
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {currentDataList?.length > 0 ? (
                  <UserTable
                    dataList={currentDataList}
                    arraySorting={arraySorting}
                    basicApiCall={callBasicApi}
                    sortObj={sortObj}
                    emergencyOverride={emergencyOverride}
                    editData={editData}
                    deleteData={deleteData}
                  />
                ) : (
                  <div className="px-3 pt-3">
                    <div className="no-data-available">{t("common.noDataAvailable")}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {notificationModalOpen && (
        <NotificationModal
          open={notificationModalOpen}
          closeModal={closeNotificationModal}
          data={currentData}
          edit={editDataIs}
        />
      )}
      {openAddUserModal && (
        <AddUserModal
          open={openAddUserModal}
          closeModal={closeAddUserModal}
          data={currentData}
          edit={editDataIs}
        />
      )}

      {confirmaModalOpen && (
        <ConfirmationModal
          open={confirmaModalOpen}
          deleteInfo={confirmInfo}
          description={confirmHeading}
          onCloseModal={confirmModalFunc}
        />
      )}
    </>
  );
};

export default withRouter(ManageUser);
